<script>
  import { onMount } from 'svelte';
  import { browser } from '$app/environment';

  const hasAPI = browser && 'IntersectionObserver' in window;

  let el = null;
  let visible = false;
  let hasBeenVisible = false;
  let observer = null;

  onMount(() => {
    if (hasAPI) {
      observer = new IntersectionObserver(
        (entries) => {
          let anyInteresting = false;
          entries.forEach((x) => {
            if (x.isIntersecting) {
              anyInteresting = true;
            }
          });

          visible = anyInteresting;
          hasBeenVisible = visible || hasBeenVisible;
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      observer.observe(el);

      return () => {
        if (!hasBeenVisible) {
          observer.unobserve(el);
        }
      };
    } else {
      visible = true;
      hasBeenVisible = true;
    }
  });

  $: if (hasBeenVisible && hasAPI) {
    observer.unobserve(el);
  }
</script>

<div bind:this={el} style="position: relative;">
  <slot visible={visible} hasBeenVisible={hasBeenVisible} />
</div>
